import React, { useState, useContext, useEffect } from 'react';
import { withStyles, makeStyles, useTheme } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import UserList from '../UserList/UserList';
import adminService from "../../services/admin.service";

import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { darkenColor } from '../../utils/appHelper';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    notesHeader: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(1.5),
    },
    dialogHeight: {
        // minHeight: "500px",
        // maxHeight: "500px"
        overflow: 'hidden'
    },
    formLabel: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    userLabel: {
        paddingLeft: '10px',
    },
    addButton: {
        position: 'relative',
        top: theme.spacing(-4),
        paddingRight: theme.spacing(1)
    },
    progress: {
        marginLeft: '50%',

    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    dialogTabPanel: {
        '& > div': {
            padding: 0
        }
    }
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 15) : theme.palette.primary.main,
        color: '#fff'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className="font500" variant="subtitle1" noWrap>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        // padding: '25px 16px',
        padding: '0px 0px',
        width: '500px',
        [theme.breakpoints.down(281)]: {
            width: '218px',
        },
        [theme.breakpoints.between(281, 322)]: {
            width: '258px',
        },
        [theme.breakpoints.between(321, 556)]: {
            width: '275px'
        },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const AddViewParticipantsDialog = (props) => {
    const classes = useStyles();
    const [selectedUsers, setSelectedUsers] = useState(props.userIds);
    const [value, setValue] = React.useState('0');
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [scrollTopList, setScrollTopList] = useState(0);
    const theme = useTheme();
    useEffect(() => {
        setLoading(true);
        if (props.groupList && props.groupList.length > 0) {
            let id = props.groupList[value].id
            adminService.getUsersByGroupId(id)
                .then(res => {
                    setLoading(false);
                    if (res.length > 0) {
                        setUsers(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                })
        }
        else {
            setLoading(false);
        }
    }, [value])

    const handleClose = (e, success) => {
        props.handleCloseClick(success);
    };

    const handleSearchTextChange = (text) => {
        setSearchText(text);
    }

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div style={{ overflow: 'auto' }}
                role="tabpanel"
                hidden={value !== index}
                id={`scrollable-auto-tabpanel-${index}`}
                aria-labelledby={`scrollable-auto-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }
    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
    }

    const handleScrollChange = (scrollTop) => {
        setScrollTopList(scrollTop);
    }

    const handleSelectUser = (checked, id) => {
        let users = [...selectedUsers];

        if (checked) {
            setSelectedUsers([...users, id]);
        } else {
            let index = users.findIndex(x => x === id);
            users.splice(index, 1);
            setSelectedUsers(users);
        }
    }
    const handleAddClick = () => {
        if ((selectedUsers && selectedUsers.length > 0) || props.showOnlyFOGroup) {
            props.handleSaveClick({ memoId: props.memoId, userIds: selectedUsers })
        }
    }

    const handleChange = (event, newValue) => {
        //  setSelectedAllUser(uniqueSelectedUsers);
        setValue(newValue);
        setScrollTopList(0);
    };
    return (
        <div>
            <Dialog maxWidth={false} onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Assign to user(s)
                </DialogTitle>
                <DialogContent dividers className={classes.dialogHeight}>
                    <Grid container alignItems='center'>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                            <div>
                                <AppBar position="static" style={{ backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 15) : theme.palette.primary.main, color: '#fff' }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"
                                        textColor="inherit"
                                        sx={{
                                            '& .MuiTab-root': { color: '#ffffff' },
                                            '& .Mui-selected': { color: '#ffffff !important' },
                                            '& .MuiTabs-indicator': { backgroundColor: '#ffffff' },
                                        }}
                                    >
                                        {props.groupList.length > 0 &&
                                            props.groupList.map((item, index) => {
                                                return <Tab key={index} value={`${index}`} label={item.name} {...a11yProps(`${index}`)} />
                                            })}
                                    </Tabs>
                                    {(loading) &&
                                        <LinearProgress color="secondary"></LinearProgress>}
                                </AppBar>

                                {props.groupList.length == 0 &&
                                    <Typography className="font500" variant="subtitle1" noWrap> No group found.</Typography>
                                }
                                {props.groupList.length > 0 &&
                                    props.groupList.map((item, index) => {
                                        return <TabPanel className={classes.dialogTabPanel} value={value} index={`${index}`}>
                                            <UserList setScrollTop={handleScrollChange} scrollTopList={scrollTopList} searchText={searchText} onSearchTextChange={handleSearchTextChange} setSelectedUsers={setSelectedUsers} groupList={props.groupList} selectedUsers={selectedUsers} handleSelectUser={handleSelectUser} value={value} users={users} showCheckBox={false} showLegend={props.showLegend} />
                                        </TabPanel>
                                    })}
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button style={{ backgroundColor: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main, color: '#ffffff' }}
                        variant='contained' onClick={handleAddClick}>Save</Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}

export default AddViewParticipantsDialog;

